import React from 'react';

import { iosVerticalScrollContentContainerStyle } from '@fhs/ui';
import { ScrollView } from '@fhs-legacy/universal-components';

import { Container } from './loyalty-claim-points.styled';

const LoyaltyClaimPointsContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <ScrollView
      paddingTop="$2"
      background="white"
      contentContainerStyle={iosVerticalScrollContentContainerStyle}
    >
      <Container>{children}</Container>
    </ScrollView>
  );
};

export default LoyaltyClaimPointsContainer;
